import React from 'react';
import { IconShoppingBag } from '@tabler/icons-react';
import { useCart } from '../../../contexts/CartContext';

const ProductCard = ({ product, onAddToCart }) => {
  const { addItem, loading } = useCart();
  const [adding, setAdding] = React.useState(false);

  const price = parseFloat(product.priceRange.minVariantPrice.amount);
  const currencyCode = product.priceRange.minVariantPrice.currencyCode;
  const image = product.images.edges[0]?.node;
  const variant = product.variants.edges[0]?.node;
  const isAvailable = variant?.availableForSale;

  const handleAddToCart = async (e) => {
    e.preventDefault();
    console.log('Add to cart clicked', { variant: variant?.id, isAvailable, adding });
    if (!isAvailable || adding) return;

    setAdding(true);
    try {
      console.log('Adding item to cart...');
      const result = await addItem(variant.id, 1);
      console.log('Item added successfully', result);
      if (onAddToCart) {
        onAddToCart();
      }
    } catch (error) {
      console.error('Failed to add to cart:', error);
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="ub-product-card">
      <div className="ub-product-image-wrapper">
        {image ? (
          <img
            src={image.url}
            alt={image.altText || product.title}
            className="ub-product-image"
          />
        ) : (
          <div className="ub-product-image-placeholder">
            <IconShoppingBag size={48} color="#c41e3a" strokeWidth={1.5} />
          </div>
        )}
        {!isAvailable && (
          <div className="ub-product-sold-out">
            <span>Sold Out</span>
          </div>
        )}
      </div>

      <div className="ub-product-info">
        <h3 className="ub-product-title">{product.title}</h3>
        {product.description && (
          <p className="ub-product-description">
            {product.description.substring(0, 100)}
            {product.description.length > 100 ? '...' : ''}
          </p>
        )}
        <div className="ub-product-footer">
          <div className="ub-product-price">
            <span className="ub-price-currency">{currencyCode}</span>
            <span className="ub-price-amount">${price.toFixed(2)}</span>
          </div>
          <button
            onClick={handleAddToCart}
            className={`ub-add-to-cart-btn ${!isAvailable || adding ? 'ub-disabled' : ''}`}
            disabled={!isAvailable || adding}
          >
            {adding ? (
              'Adding...'
            ) : (
              <>
                <IconShoppingBag size={20} strokeWidth={2} />
                <span>Add to Cart</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
